(function () {
  if (customElements.get('compare-slider')) return;

  class CompareSlider extends HTMLElement {
    connectedCallback() {
      this.handle = this.querySelector('[data-cmp-handle]');
      this.pos = 50;
      this.dragging = false;
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);

      this.addEventListener('pointerdown', this.onDown);
      if (this.handle) this.handle.addEventListener('keydown', this.onKey.bind(this));

      this.demoed = false;
      this.observe();
    }

    setPos(p) {
      this.pos = Math.max(2, Math.min(98, p));
      this.style.setProperty('--pos', this.pos + '%');
      if (this.handle) this.handle.setAttribute('aria-valuenow', Math.round(this.pos));
    }

    fromEvent(e) {
      var rect = this.getBoundingClientRect();
      this.setPos(((e.clientX - rect.left) / rect.width) * 100);
    }

    onDown(e) {
      this.classList.remove('cmp--anim');
      this.dragging = true;
      try { this.setPointerCapture(e.pointerId); } catch (err) {}
      this.fromEvent(e);
      this.addEventListener('pointermove', this.onMove);
      this.addEventListener('pointerup', this.onUp);
      this.addEventListener('pointercancel', this.onUp);
      e.preventDefault();
    }

    onMove(e) {
      if (this.dragging) this.fromEvent(e);
    }

    onUp() {
      this.dragging = false;
      this.removeEventListener('pointermove', this.onMove);
      this.removeEventListener('pointerup', this.onUp);
      this.removeEventListener('pointercancel', this.onUp);
    }

    onKey(e) {
      if (e.key === 'ArrowLeft') { this.setPos(this.pos - 3); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { this.setPos(this.pos + 3); e.preventDefault(); }
    }

    /* Nudge the handle when scrolled into view to show it's interactive */
    observe() {
      var self = this;
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !self.demoed) {
              self.demoed = true;
              self.io.disconnect();
              self.demo();
            }
          });
        },
        { threshold: 0.4 }
      );
      this.io.observe(this);
    }

    demo() {
      if (this.reduce) return;
      var self = this;
      this.classList.add('cmp--anim');
      var seq = [32, 68, 50];
      var i = 0;
      function next() {
        if (i >= seq.length) {
          window.setTimeout(function () { self.classList.remove('cmp--anim'); }, 500);
          return;
        }
        self.setPos(seq[i]);
        i++;
        window.setTimeout(next, 520);
      }
      window.setTimeout(next, 300);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  customElements.define('compare-slider', CompareSlider);
})();
